import { View } from 'react-native';
import { Button, Surface, Text, useTheme } from 'react-native-paper';
import { Sidebar, SIDEBAR_WIDTH } from './Sidebar';
import { useTranslation } from 'react-i18next';

interface DriverProfileRecoveryStateProps {
  desktopSidebarVisible: boolean;
  width: number;
  handleLogout: () => Promise<void> | void;
  hasOwner: boolean;
  selectedProfile: 'Owner' | 'Driver';
  onSwitchProfile?: (newProfile: 'Owner' | 'Driver') => void;
  onOpenVehicleSetup: () => void;
}

export function DriverProfileRecoveryState({
  desktopSidebarVisible,
  width,
  handleLogout,
  hasOwner,
  selectedProfile,
  onSwitchProfile,
  onOpenVehicleSetup,
}: DriverProfileRecoveryStateProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <View style={{ flex: 1, backgroundColor: theme.colors.background, flexDirection: 'row' }}>
      {desktopSidebarVisible && (
        <Sidebar
          isOpen={true}
          onClose={() => {}}
          screenWidth={width}
          onLogout={handleLogout}
          isOwner={hasOwner}
          isDriver={true}
          selectedProfile={selectedProfile}
          onSwitchProfile={onSwitchProfile}
        />
      )}

      <Surface
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          padding: 24,
          ...(desktopSidebarVisible ? { marginLeft: SIDEBAR_WIDTH } : {}),
        }}
      >
        <View style={{ width: '100%', maxWidth: 520, gap: 12 }} testID="driver-recovery-state">
          <Text variant="headlineSmall">
            {t('driverDashboard.noVehicleAssignedTitle', 'No vehicle assigned')}
          </Text>
          <Text variant="bodyMedium">
            {hasOwner
              ? t(
                'driverDashboard.noVehicleAssignedRecoveryMessage',
                'You are in Driver mode but do not have a vehicle assigned yet. You can continue driver setup or switch back to the Owner profile.'
              )
              : t(
                'driverDashboard.noVehicleAssignedDriverOnlyMessage',
                'Your company has not assigned a vehicle yet. You can continue vehicle setup now or return later.'
              )}
          </Text>
          <Button
            mode="contained"
            onPress={onOpenVehicleSetup}
            testID="driver-recovery-open-vehicle-setup"
          >
            {t('driverDashboard.continueVehicleSetup', 'Continue vehicle setup')}
          </Button>
          {hasOwner && onSwitchProfile && (
            <Button
              mode="outlined"
              onPress={() => onSwitchProfile('Owner')}
              testID="driver-recovery-switch-owner"
            >
              {t('switchToOwner', 'Switch to Owner')}
            </Button>
          )}
        </View>
      </Surface>
    </View>
  );
}
